import _typeof from"@babel/runtime/helpers/typeof";/**
 * Gets a link for a specified page/request
 *
 * @param {string}  url    The base url
 * @param {Object=} params Object of parameters for the URL
 *
 * @returns {string} Returns the requested URL
 */export default(function(url){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var query=[];// create an array of params
if(_typeof(params)==='object'){try{for(var _i=0,_Object$keys=Object.keys(params);_i<_Object$keys.length;_i++){var param=_Object$keys[_i];query[query.length]="".concat(encodeURIComponent(param),"=").concat(encodeURIComponent(params[param]));}}catch(e){}}return url+(query.length>0?"?".concat(query.join('&').replace(/%20/g,'+')):'');});
//# sourceMappingURL=buildURL.js.map